module.exports = "/assets/data/f04490ab5c6371abee70af5712018a7a-SN16.data.json";